import router from "@/router";
import { imageManager } from "@/services/image-manager";
import { defineStore } from "pinia";
import { loginManager } from "@/services/login-manager";
import { sortManager } from "@/services/sort-manager";

export const useMainStore = defineStore({
  id: "Main",
  state: () => {
    return {
      loading: true,
      counter: 0,
      webViewUrl: "",
      transitionMode: "in-out",
      ranges: {},
      range: {},
      vehicles: {},
      vehicle: {},
      error: null,
      uid: "",
      initialized: true,
      code: "",
      isIdle: false,
      translations: {},
      locale: "fr",
      currency: "€",
      domain: "",
      pingState: "pending",
      videoList: "PLu2JW5YfPSpAsI0qP8teZZA-jm2tAJr8R",
      idleScreen: false,
      secretMenu: false,
      characteristic: null,
      background: false,
      jpoUrl: "",
    };
  },

  actions: {
    fetchData() {
      this.loading = true;
      this.pingState = "sending";
      loginManager.ping().then((res) => {
        this.pingState = "sent";
        if (res && res.success) {
          if (res) {
            useMainStore().setJpoUrl(res.jpo_url);
            localStorage.setItem("aixam-jpo-url", res.jpo_url);
          }
          this.pingState = "succeed";
          this.fetchTranslations().then(() => {
            this.pingState = "translations";
            loginManager.call("/api/tv/ranges").then((data) => {
              this.pingState = "ranges";
              this.setRanges(data.ranges);
              if (router.currentRoute.value.name === "Error") {
                router.push({ name: "Home" });
              }
              imageManager.preloadImages(data.ranges).then((res) => {
                if (res && res.success) {
                  this.pingState = "ready";
                  this.loading = false;
                }
              });
            });
          });
        }
      });
    },

    setCharacteristic(characteristic) {
      this.characteristic = characteristic;
    },

    setBackground(value) {
      this.background = value;
    },

    setJpoUrl(value) {
      this.jpoUrl = value;
    },

    fetchTranslations() {
      return loginManager.call("/api/tv/translations").then((translations) => {
        this.translations = translations;
      });
    },

    incrementCounter() {
      this.counter++;
    },

    setIdleScreen(value) {
      this.idleScreen = value;
    },

    setCounter(value) {
      this.counter = value;
    },

    resetCounter() {
      this.counter = 0;
    },

    setRanges(ranges) {
      this.ranges = sortManager.sort(ranges, "sort", "ASC");
      Object.values(this.ranges).forEach((range) => {
        let energies = [];
        let fromInstallment = null;
        Object.values(range.vehicles).forEach((vehicle) => {
          Object.values(vehicle.models).forEach((model) => {
            if (
              model.motors[0].label &&
              !energies.includes(model.motors[0].label)
            ) {
              energies.push(model.motors[0].label);
            }
            if (
              model.motors[0].installment &&
              (!fromInstallment ||
                fromInstallment > model.motors[0].installment)
            ) {
              fromInstallment = model.motors[0].installment;
            }
          });
        });
        range["energies"] = energies;
        range["fromInstallment"] = fromInstallment;
      });
    },

    toggleRange(id) {
      this.range = Object.values(this.ranges).find((item) => item.id === id);
      if (this.range && this.range.vehicles) {
        this.vehicles = {};
        Object.values(this.range.vehicles).forEach((vehicle) => {
          this.vehicles = Object.values(this.vehicles).concat(vehicle.models);
        });
      }
    },

    toggleVehicle(id = null) {
      if (id) {
        this.vehicle = Object.values(this.vehicles).find(
          (item) => item.id === id,
        );
      } else {
        this.vehicle = this.vehicles[0];
      }
      if (this.vehicle) {
        this.characteristic = this.vehicle.motors[0].characteristics[0];
      }
    },

    setStoreUid(uid) {
      this.uid = uid;
      window.localStorage.setItem("aixam-device-uid", uid);
    },

    setIdle(value) {
      this.isIdle = value;
    },

    setSecretMenu(value) {
      this.secretMenu = value;
    },

    setDomain(value) {
      this.domain = value;
    },

    setError(error) {
      this.error = error;
    },
    setCode(code) {
      this.code = code;
    },

    setInitialized(value) {
      this.initialized = value;
    },

    setWebviewUrl(url) {
      this.webViewUrl = url;
    },

    setLoading(value) {
      this.loading = value;
    },
  },
});
